export enum YianOrdersActionTypes {
  API_RESPONSE_SUCCESS = '@@yianOrders/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@yianOrders/API_RESPONSE_ERROR',

  LIST_YIANORDERS = '@@yianOrders/LIST_YIANORDERS',

  RESET = '@@yianOrders/RESET',
}